import { render, staticRenderFns } from "./jurisdiction.vue?vue&type=template&id=28c56e35&scoped=true&"
import script from "./jurisdiction.vue?vue&type=script&lang=js&"
export * from "./jurisdiction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c56e35",
  null
  
)

export default component.exports